import { useState } from 'react';
import { Controller } from 'react-hook-form';
import { FormHelperText, InputAdornment, TextField, Typography } from '@mui/material';
import { ICONS } from 'src/assets/library';
import { useTranslation } from 'react-i18next';

const CustomTextField = ({
  endIcon = false,
  controller,
  isPassword = false,
  label,
  type = 'text',
  required = true,
  icon,
  allowPastDates = false,
  pastDatesOnly = false,
  ...props
}) => {
  const [isShowPassword, setIsShowPassword] = useState(false);
  const togglePassword = () => setIsShowPassword(!isShowPassword);
  const { t } = useTranslation();
  return (
    <div>
      {label && (
        <>
          <Typography variant="caption">{label}</Typography>
          <br />
        </>
      )}

      {controller ? (
        <>
          <Controller
            control={controller.control}
            name={controller.name}
            rules={{ required }}
            render={({ field: { onChange, value, onBlur } }) => (
              <TextField
                className="autofill"
                InputProps={{
                  startAdornment: icon && <InputAdornment position="start">{icon}</InputAdornment>,
                  endAdornment: isPassword ? (
                    <InputAdornment sx={{ cursor: 'pointer' }} onClick={togglePassword} position="end">
                      {!isShowPassword ? ICONS.visible : ICONS.hide}
                    </InputAdornment>
                  ) : (
                    endIcon
                  ),
                }}
                fullWidth
                type={isShowPassword ? 'text' : type}
                size="small"
                onChange={onChange}
                error={Boolean(controller.errors)}
                value={value ? value : ''}
                onBlur={onBlur}
                disabled={controller.disabled}
                inputProps={{
                  // Date bounds:
                  //  - pastDatesOnly: only dates before today (e.g. date of birth)
                  //  - allowPastDates: no bound at all, past and future both selectable
                  //  - default: today onwards (e.g. a new delivery date)
                  ...(type === 'date'
                    ? pastDatesOnly
                      ? { max: new Date(Date.now() - 86400000).toLocaleDateString('en-CA') }
                      : allowPastDates
                        ? {}
                        : { min: new Date().toLocaleDateString('en-CA') }
                    : {}),
                  ...props.inputProps,
                }}
                {...props}
              />
            )}
          />
          {controller.errors && (
            <FormHelperText sx={{ color: 'error.main' }}>{t(controller.errors.message)}</FormHelperText>
          )}
        </>
      ) : (
        <TextField
          type={type}
          fullWidth
          size="small"
          InputProps={{
            startAdornment: icon && <InputAdornment position="start">{icon}</InputAdornment>,
            endAdornment: endIcon && endIcon,
          }}
          {...props}
        />
      )}
    </div>
  );
};

export default CustomTextField;
